import React from "react";

const Tab = ({ tabsList = [], onClick, activeTab }) => {
  return (
    <div className="border-b border-gray-300">
      <nav className="flex space-x-8">
        {tabsList.map((tab, idx) => {
          const isActive = activeTab === tab.id || activeTab === idx;
          return (
            <button
              key={tab.id || idx}
              className={`py-3 px-1 border-b-2 font-medium text-sm transition-colors duration-150 ${
                isActive
                  ? "border-primary text-primary"
                  : "border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
              onClick={() => onClick(tab.id || "")}
            >
              <span className="flex items-center gap-2">
                {tab.name}
                {tab.count !== undefined && (
                  <span
                    className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                      isActive
                        ? "bg-primary text-white"
                        : "bg-gray-100 text-gray-800"
                    }`}
                  >
                    {tab.count}
                  </span>
                )}
              </span>
            </button>
          );
        })}
      </nav>
    </div>
  );
};

export default Tab;
